[
  {
    "id": 4,
    "name": "Health Sciences",
    "slug": "health-sciences",
    "description": "The applied sciences dedicated to improving human and animal health through medicine, nursing, dentistry, pharmacy, public health, clinical research, and healthcare delivery systems, focusing on disease prevention, diagnosis, treatment, and wellness",
    "works_count": 471,
    "created_at": "2025-07-11T13:44:30.572372",
    "updated_at": "2025-07-11T13:44:30.572372",
    "fields": [
      {
        "id": 35,
        "domain_id": 4,
        "name": "Dentistry",
        "slug": "dentistry",
        "description": "The branch of medicine focused on oral health, including the diagnosis, prevention, and treatment of diseases affecting teeth, gums, and oral structures, as well as oral surgery, orthodontics, and the relationship between oral and systemic health",
        "works_count": 12,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3500,
            "field_id": 35,
            "name": "General Dentistry",
            "slug": "general-dentistry",
            "description": "Comprehensive dental care, including preventive dentistry, restorative procedures, diagnosis of oral diseases, patient management, and primary dental healthcare delivery",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3504,
            "field_id": 35,
            "name": "Oral Surgery",
            "slug": "oral-surgery",
            "description": "Surgical procedures of the mouth and jaw, including tooth extraction, dental implants, jaw surgery, oral pathology, trauma management, and maxillofacial reconstruction",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3505,
            "field_id": 35,
            "name": "Orthodontics",
            "slug": "orthodontics",
            "description": "Correction of dental and facial irregularities, including braces, aligners, jaw growth modification, surgical orthodontics, and the biomechanics of tooth movement",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3506,
            "field_id": 35,
            "name": "Periodontics",
            "slug": "periodontics",
            "description": "Gum disease and supporting structures of teeth, including gingivitis, periodontitis, gum surgery, dental implants, and regenerative periodontal procedures",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          }
        ]
      },
      {
        "id": 36,
        "domain_id": 4,
        "name": "Health Professions",
        "slug": "health-professions",
        "description": "The allied health disciplines supporting healthcare delivery, including physical therapy, occupational therapy, public health, health administration, nutrition, medical technology, and other specialized healthcare services",
        "works_count": 42,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3603,
            "field_id": 36,
            "name": "Complementary and Manual Therapy",
            "slug": "complementary-and-manual-therapy",
            "description": "Alternative and hands-on therapeutic approaches, including chiropractic, massage therapy, osteopathy, acupuncture in allied health, and integrative manual therapies",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3604,
            "field_id": 36,
            "name": "Emergency Medical Services",
            "slug": "emergency-medical-services",
            "description": "Pre-hospital emergency care, including paramedic practice, emergency medical technician training, disaster response, trauma care, and emergency medical system management",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3600,
            "field_id": 36,
            "name": "General Health Professions",
            "slug": "general-health-professions",
            "description": "Broad allied health topics, including interprofessional education, healthcare teams, professional development, health promotion, and integrated healthcare delivery",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3605,
            "field_id": 36,
            "name": "Health Information Management",
            "slug": "health-information-management",
            "description": "Management of health data and information systems, including medical coding, health records administration, data privacy, healthcare analytics, and clinical documentation",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3607,
            "field_id": 36,
            "name": "Medical Laboratory Technology",
            "slug": "medical-laboratory-technology",
            "description": "Clinical laboratory science and diagnostics, including clinical chemistry, hematology, microbiology, immunology, molecular diagnostics, and laboratory quality management",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3608,
            "field_id": 36,
            "name": "Medical Terminology",
            "slug": "medical-terminology",
            "description": "Medical language and communication, including anatomical terminology, clinical vocabulary, medical documentation, terminology standards, and healthcare communication systems",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3609,
            "field_id": 36,
            "name": "Occupational Therapy",
            "slug": "occupational-therapy",
            "description": "Helping people participate in daily activities, including functional assessment, adaptive equipment, sensory integration, work rehabilitation, and occupation-based interventions",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3611,
            "field_id": 36,
            "name": "Pharmacy",
            "slug": "pharmacy",
            "description": "Medication therapy and pharmaceutical care, including clinical pharmacy, community pharmacy, hospital pharmacy, medication safety, and pharmaceutical patient care",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3612,
            "field_id": 36,
            "name": "Physical Therapy, Sports Therapy and Rehabilitation",
            "slug": "physical-therapy-sports-therapy-and-rehabilitation",
            "description": "Movement science and rehabilitation, including musculoskeletal therapy, neurological rehabilitation, sports injury management, exercise prescription, and functional restoration",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3614,
            "field_id": 36,
            "name": "Radiological and Ultrasound Technology",
            "slug": "radiological-and-ultrasound-technology",
            "description": "Medical imaging technology and practice, including radiography, sonography, CT, MRI, radiation safety, image quality, and diagnostic imaging procedures",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          },
          {
            "id": 3616,
            "field_id": 36,
            "name": "Speech and Hearing",
            "slug": "speech-and-hearing",
            "description": "Communication disorders and audiology, including speech-language pathology, hearing assessment, cochlear implants, swallowing disorders, and communication rehabilitation",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.82823",
            "updated_at": "2025-07-11T14:10:36.82823"
          }
        ]
      },
      {
        "id": 27,
        "domain_id": 4,
        "name": "Medicine",
        "slug": "medicine",
        "description": "The science and practice of diagnosing, treating, and preventing disease, including clinical medicine, surgery, internal medicine, pediatrics, psychiatry, medical research, and the advancement of therapeutic interventions for human health",
        "works_count": 402,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2702,
            "field_id": 27,
            "name": "Anatomy",
            "slug": "anatomy",
            "description": "The structure of the human body, including gross anatomy, histology, embryology, neuroanatomy, and the application of anatomical knowledge to clinical practice and medical education",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2703,
            "field_id": 27,
            "name": "Anesthesiology and Pain Medicine",
            "slug": "anesthesiology-and-pain-medicine",
            "description": "The practice of anesthesia and pain management, including perioperative care, regional anesthesia, critical care, chronic pain treatment, and the development of new analgesic approaches",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2704,
            "field_id": 27,
            "name": "Biochemistry",
            "slug": "biochemistry",
            "description": "The chemical basis of physiological and pathological processes, including clinical biochemistry, metabolic pathways, molecular diagnostics, and the biochemical mechanisms of disease",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2705,
            "field_id": 27,
            "name": "Cardiology and Cardiovascular Medicine",
            "slug": "cardiology-and-cardiovascular-medicine",
            "description": "The study and treatment of heart and vascular diseases, including coronary artery disease, heart failure, arrhythmias, interventional cardiology, and cardiovascular prevention",
            "works_count": 29,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2707,
            "field_id": 27,
            "name": "Complementary and alternative medicine",
            "slug": "complementary-and-alternative-medicine",
            "description": "Non-conventional medical practices, including traditional medicine, acupuncture, herbal medicine, mind-body therapies, and the integration of complementary approaches with conventional medicine",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2706,
            "field_id": 27,
            "name": "Critical Care and Intensive Care Medicine",
            "slug": "critical-care-and-intensive-care-medicine",
            "description": "The management of critically ill patients, including mechanical ventilation, hemodynamic support, sepsis management, organ failure, and innovations in intensive care unit practices",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2708,
            "field_id": 27,
            "name": "Dermatology",
            "slug": "dermatology",
            "description": "The diagnosis and treatment of skin disorders, including inflammatory skin diseases, skin cancer, cosmetic dermatology, pediatric dermatology, and dermatologic surgery",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2711,
            "field_id": 27,
            "name": "Emergency Medicine",
            "slug": "emergency-medicine",
            "description": "Acute care medicine in emergency settings, including trauma management, resuscitation, emergency procedures, disaster medicine, and the organization of emergency medical services",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2712,
            "field_id": 27,
            "name": "Endocrinology, Diabetes and Metabolism",
            "slug": "endocrinology-diabetes-and-metabolism",
            "description": "Hormonal disorders and metabolic diseases, including diabetes mellitus, thyroid disorders, obesity, metabolic syndrome, and the endocrine regulation of metabolism",
            "works_count": 18,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2713,
            "field_id": 27,
            "name": "Epidemiology",
            "slug": "epidemiology",
            "description": "The patterns and causes of disease in populations, including disease surveillance, outbreak investigation, clinical trials, health disparities, and the development of public health interventions",
            "works_count": 30,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2714,
            "field_id": 27,
            "name": "Family Practice",
            "slug": "family-practice",
            "description": "Comprehensive primary care across the lifespan, including preventive medicine, chronic disease management, patient-centered care, and the coordination of healthcare services",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2715,
            "field_id": 27,
            "name": "Gastroenterology",
            "slug": "gastroenterology",
            "description": "Diseases of the digestive system, including inflammatory bowel disease, liver disease, gastrointestinal cancers, endoscopy, and functional gastrointestinal disorders",
            "works_count": 13,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2700,
            "field_id": 27,
            "name": "General Medicine",
            "slug": "general-medicine",
            "description": "Interdisciplinary research spanning multiple areas of medicine that bridges traditional boundaries within this field",
            "works_count": 24,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2716,
            "field_id": 27,
            "name": "Genetics",
            "slug": "genetics",
            "description": "Medical genetics and genomic medicine, including genetic testing, inherited diseases, pharmacogenomics, genetic counseling, and the application of genomics to personalized medicine",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2717,
            "field_id": 27,
            "name": "Geriatrics and Gerontology",
            "slug": "geriatrics-and-gerontology",
            "description": "Healthcare for older adults, including age-related diseases, frailty, cognitive decline, polypharmacy, long-term care, and strategies for healthy aging",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2718,
            "field_id": 27,
            "name": "Health Informatics",
            "slug": "health-informatics",
            "description": "Information technology in healthcare, including electronic health records, clinical decision support, telemedicine, health data analytics, and the use of AI in medicine",
            "works_count": 12,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2720,
            "field_id": 27,
            "name": "Hematology",
            "slug": "hematology",
            "description": "Blood disorders and diseases, including anemia, bleeding disorders, thrombosis, hematologic malignancies, transfusion medicine, and stem cell transplantation",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2721,
            "field_id": 27,
            "name": "Hepatology",
            "slug": "hepatology",
            "description": "Liver diseases and disorders, including viral hepatitis, cirrhosis, fatty liver disease, liver cancer, liver transplantation, and the management of portal hypertension",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2723,
            "field_id": 27,
            "name": "Immunology and Allergy",
            "slug": "immunology-and-allergy",
            "description": "Immune system disorders and allergic diseases, including autoimmune diseases, immunodeficiencies, allergic rhinitis, asthma, anaphylaxis, and immunotherapy approaches",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2725,
            "field_id": 27,
            "name": "Infectious Diseases",
            "slug": "infectious-diseases",
            "description": "The prevention and treatment of infections, including antimicrobial therapy, emerging infectious diseases, hospital-acquired infections, tropical medicine, and vaccine development",
            "works_count": 17,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2724,
            "field_id": 27,
            "name": "Internal Medicine",
            "slug": "internal-medicine",
            "description": "Comprehensive adult medicine, including diagnosis and management of complex medical conditions, hospital medicine, preventive care, and the coordination of subspecialty care",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.691215",
            "updated_at": "2025-07-11T14:10:35.691215"
          },
          {
            "id": 2726,
            "field_id": 27,
            "name": "Microbiology",
            "slug": "microbiology",
            "description": "Medical microbiology and infectious agents, including bacterial, viral, fungal, and parasitic pathogens, antimicrobial resistance, diagnostic microbiology, and infection control",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2727,
            "field_id": 27,
            "name": "Nephrology",
            "slug": "nephrology",
            "description": "Kidney diseases and disorders, including chronic kidney disease, acute kidney injury, dialysis, kidney transplantation, electrolyte disorders, and hypertension",
            "works_count": 25,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2728,
            "field_id": 27,
            "name": "Neurology",
            "slug": "neurology",
            "description": "Diseases of the nervous system, including stroke, epilepsy, movement disorders, neurodegenerative diseases, headaches, and the application of neuroimaging to diagnosis",
            "works_count": 18,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2729,
            "field_id": 27,
            "name": "Obstetrics and Gynecology",
            "slug": "obstetrics-and-gynecology",
            "description": "Women's reproductive health, including pregnancy care, childbirth, gynecologic disorders, reproductive endocrinology, gynecologic oncology, and maternal-fetal medicine",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2730,
            "field_id": 27,
            "name": "Oncology",
            "slug": "oncology",
            "description": "Cancer diagnosis and treatment, including medical oncology, radiation oncology, surgical oncology, cancer immunotherapy, precision oncology, and palliative care",
            "works_count": 16,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2731,
            "field_id": 27,
            "name": "Ophthalmology",
            "slug": "ophthalmology",
            "description": "Eye diseases and vision disorders, including cataracts, glaucoma, retinal diseases, refractive surgery, pediatric ophthalmology, and advances in ophthalmic surgery",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2732,
            "field_id": 27,
            "name": "Orthopedics and Sports Medicine",
            "slug": "orthopedics-and-sports-medicine",
            "description": "Musculoskeletal disorders and injuries, including joint replacement, spine surgery, sports injuries, trauma surgery, pediatric orthopedics, and rehabilitation",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2733,
            "field_id": 27,
            "name": "Otorhinolaryngology",
            "slug": "otorhinolaryngology",
            "description": "Ear, nose, and throat disorders, including hearing loss, sinusitis, voice disorders, head and neck cancer, pediatric ENT, and advances in ENT surgery",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2734,
            "field_id": 27,
            "name": "Pathology and Forensic Medicine",
            "slug": "pathology-and-forensic-medicine",
            "description": "Disease diagnosis through laboratory analysis, including anatomic pathology, clinical pathology, molecular pathology, autopsy, and the application of pathology to legal investigations",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2735,
            "field_id": 27,
            "name": "Pediatrics, Perinatology and Child Health",
            "slug": "pediatrics-perinatology-and-child-health",
            "description": "Healthcare for infants, children, and adolescents, including neonatology, developmental pediatrics, pediatric subspecialties, childhood vaccinations, and adolescent medicine",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2736,
            "field_id": 27,
            "name": "Pharmacology",
            "slug": "pharmacology",
            "description": "Drug action and therapeutics, including clinical pharmacology, drug development, pharmacokinetics, pharmacodynamics, adverse drug reactions, and personalized medicine approaches",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2737,
            "field_id": 27,
            "name": "Physiology",
            "slug": "physiology",
            "description": "Normal body function and regulation, including cardiovascular physiology, respiratory physiology, neurophysiology, exercise physiology, and the physiological basis of disease",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2738,
            "field_id": 27,
            "name": "Psychiatry and Mental health",
            "slug": "psychiatry-and-mental-health",
            "description": "Mental health disorders and treatment, including mood disorders, psychotic disorders, anxiety disorders, psychotherapy, psychopharmacology, and community mental health",
            "works_count": 15,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2739,
            "field_id": 27,
            "name": "Public Health, Environmental and Occupational Health",
            "slug": "public-health-environmental-and-occupational-health",
            "description": "Population health and prevention, including health promotion, disease prevention, environmental health hazards, occupational safety, health policy, and global health initiatives",
            "works_count": 20,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2740,
            "field_id": 27,
            "name": "Pulmonary and Respiratory Medicine",
            "slug": "pulmonary-and-respiratory-medicine",
            "description": "Lung diseases and respiratory disorders, including asthma, COPD, pneumonia, lung cancer, sleep disorders, pulmonary hypertension, and critical care pulmonology",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2741,
            "field_id": 27,
            "name": "Radiology, Nuclear Medicine and Imaging",
            "slug": "radiology-nuclear-medicine-and-imaging",
            "description": "Medical imaging and image-guided procedures, including diagnostic radiology, interventional radiology, nuclear medicine, radiation therapy planning, and advances in imaging technology",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2742,
            "field_id": 27,
            "name": "Rehabilitation",
            "slug": "rehabilitation",
            "description": "Restoration of function after illness or injury, including physical medicine, occupational therapy, speech therapy, cardiac rehabilitation, and assistive technology",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2743,
            "field_id": 27,
            "name": "Reproductive Medicine",
            "slug": "reproductive-medicine",
            "description": "Fertility and reproductive health, including infertility treatment, assisted reproductive technology, reproductive endocrinology, contraception, and preservation of fertility",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2745,
            "field_id": 27,
            "name": "Rheumatology",
            "slug": "rheumatology",
            "description": "Autoimmune and inflammatory joint diseases, including rheumatoid arthritis, lupus, osteoarthritis, gout, vasculitis, and the development of targeted therapies",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2746,
            "field_id": 27,
            "name": "Surgery",
            "slug": "surgery",
            "description": "Surgical treatment of disease and injury, including general surgery, minimally invasive surgery, robotic surgery, transplant surgery, surgical oncology, and perioperative care",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.998389",
            "updated_at": "2025-07-11T14:10:35.998389"
          },
          {
            "id": 2747,
            "field_id": 27,
            "name": "Transplantation",
            "slug": "transplantation",
            "description": "Organ and tissue transplantation, including donor selection, immunosuppression, rejection prevention, organ preservation, xenotransplantation, and transplant outcomes",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2748,
            "field_id": 27,
            "name": "Urology",
            "slug": "urology",
            "description": "Urinary tract and male reproductive disorders, including prostate disease, kidney stones, bladder cancer, erectile dysfunction, pediatric urology, and urologic surgery",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          }
        ]
      },
      {
        "id": 29,
        "domain_id": 4,
        "name": "Nursing",
        "slug": "nursing",
        "description": "The art and science of caring for individuals across the lifespan, including clinical nursing practice, patient advocacy, health promotion, disease prevention, nursing education, and the delivery of compassionate healthcare in diverse settings",
        "works_count": 9,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2900,
            "field_id": 29,
            "name": "General Nursing",
            "slug": "general-nursing",
            "description": "Interdisciplinary research spanning multiple areas of nursing that bridges traditional boundaries within this field",
            "works_count": 0,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2910,
            "field_id": 29,
            "name": "Issues, ethics and legal aspects",
            "slug": "issues-ethics-and-legal-aspects",
            "description": "Ethical and legal considerations in nursing practice, including patient rights, informed consent, end-of-life care, professional ethics, and healthcare law affecting nursing",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2911,
            "field_id": 29,
            "name": "Leadership and Management",
            "slug": "leadership-and-management",
            "description": "Nursing leadership and healthcare management, including nurse management, healthcare quality improvement, organizational behavior, change management, and nursing workforce development",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2916,
            "field_id": 29,
            "name": "Nutrition and Dietetics",
            "slug": "nutrition-and-dietetics",
            "description": "Nutritional science and dietary management, including clinical nutrition, community nutrition, food service management, nutrition counseling, and the role of diet in health and disease",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2922,
            "field_id": 29,
            "name": "Research and Theory",
            "slug": "research-and-theory",
            "description": "Nursing research methodology and theoretical frameworks, including evidence-based practice, nursing theories, research design, qualitative and quantitative methods, and knowledge translation",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          }
        ]
      },
      {
        "id": 34,
        "domain_id": 4,
        "name": "Veterinary",
        "slug": "veterinary",
        "description": "The medical care and treatment of animals, including companion animals, livestock, wildlife, and exotic species, encompassing veterinary medicine, surgery, preventive care, public health, and the critical role of animal health in human wellbeing",
        "works_count": 6,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3402,
            "field_id": 34,
            "name": "Equine",
            "slug": "equine",
            "description": "Horse health and medicine, including equine surgery, internal medicine, reproduction, sports medicine, nutrition, and the management of equine diseases and injuries",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3400,
            "field_id": 34,
            "name": "General Veterinary",
            "slug": "general-veterinary",
            "description": "Interdisciplinary research spanning multiple areas of veterinary that bridges traditional boundaries within this field",
            "works_count": 1,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 3404,
            "field_id": 34,
            "name": "Small Animals",
            "slug": "small-animals",
            "description": "Companion animal medicine, including dogs, cats, and exotic pets, covering internal medicine, surgery, behavior, nutrition, and preventive care for household pets",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          }
        ]
      }
    ]
  },
  {
    "id": 1,
    "name": "Life Sciences",
    "slug": "life-sciences",
    "description": "The study of living organisms and life processes, encompassing biology, ecology, genetics, molecular biology, agriculture, zoology, botany, and the fundamental mechanisms that govern life from the molecular to the ecosystem level",
    "works_count": 357,
    "created_at": "2025-07-11T13:44:30.572372",
    "updated_at": "2025-07-11T13:44:30.572372",
    "fields": [
      {
        "id": 11,
        "domain_id": 1,
        "name": "Agricultural and Biological Sciences",
        "slug": "agricultural-and-biological-sciences",
        "description": "The study of living organisms and their interactions with the environment, including agriculture, ecology, plant biology, animal biology, conservation, forestry, marine biology, and sustainable food production systems",
        "works_count": 65,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1102,
            "field_id": 11,
            "name": "Agronomy and Crop Science",
            "slug": "agronomy-and-crop-science",
            "description": "The science of soil management and crop production, including plant breeding, crop physiology, soil fertility, irrigation systems, pest management, and sustainable farming practices to optimize agricultural yield and quality",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1103,
            "field_id": 11,
            "name": "Animal Science and Zoology",
            "slug": "animal-science-and-zoology",
            "description": "The comprehensive study of animal biology, behavior, physiology, and ecology, including livestock production, animal nutrition, breeding, welfare, wildlife conservation, and the evolutionary relationships among animal species",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1104,
            "field_id": 11,
            "name": "Aquatic Science",
            "slug": "aquatic-science",
            "description": "The interdisciplinary study of freshwater and marine ecosystems, including limnology, oceanography, aquatic ecology, fisheries science, water quality, and the conservation of aquatic biodiversity and resources",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1105,
            "field_id": 11,
            "name": "Ecology, Evolution, Behavior and Systematics",
            "slug": "ecology-evolution-behavior-and-systematics",
            "description": "The integrated study of how organisms interact with their environment, evolve over time, exhibit behaviors, and are classified, including population dynamics, community ecology, evolutionary biology, behavioral ecology, and taxonomic relationships",
            "works_count": 25,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1106,
            "field_id": 11,
            "name": "Food Science",
            "slug": "food-science",
            "description": "The application of biological, chemical, and physical sciences to study food properties, processing, preservation, safety, and nutrition, including food chemistry, microbiology, engineering, sensory analysis, and product development",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1107,
            "field_id": 11,
            "name": "Forestry",
            "slug": "forestry",
            "description": "The science and practice of managing forest ecosystems for timber production, conservation, recreation, and ecosystem services, including silviculture, forest ecology, fire management, and sustainable forest resource utilization",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1100,
            "field_id": 11,
            "name": "General Agricultural and Biological Sciences",
            "slug": "general-agricultural-and-biological-sciences",
            "description": "Broad interdisciplinary research spanning multiple areas of agriculture and biology, including integrated approaches to food security, biotechnology applications, environmental sustainability, and the interface between agricultural systems and natural ecosystems",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1108,
            "field_id": 11,
            "name": "Horticulture",
            "slug": "horticulture",
            "description": "The science and art of cultivating fruits, vegetables, flowers, and ornamental plants, including plant propagation, greenhouse management, landscape design, post-harvest technology, and urban agriculture",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1109,
            "field_id": 11,
            "name": "Insect Science",
            "slug": "insect-science",
            "description": "The study of insects and their interactions with humans, plants, and ecosystems, including entomology, pest management, pollinator biology, insect physiology, behavior, systematics, and their roles in agriculture and disease transmission",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1110,
            "field_id": 11,
            "name": "Plant Science",
            "slug": "plant-science",
            "description": "The comprehensive study of plant biology, including plant physiology, molecular biology, genetics, pathology, biotechnology, and the development of improved crop varieties for food, fiber, and environmental applications",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1111,
            "field_id": 11,
            "name": "Soil Science",
            "slug": "soil-science",
            "description": "The study of soil as a natural resource, including soil formation, classification, mapping, fertility, chemistry, biology, physics, and management for agricultural production and environmental protection",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          }
        ]
      },
      {
        "id": 13,
        "domain_id": 1,
        "name": "Biochemistry, Genetics and Molecular Biology",
        "slug": "biochemistry-genetics-and-molecular-biology",
        "description": "The molecular basis of life, exploring the chemical processes within living organisms, genetic inheritance, DNA/RNA structure and function, protein synthesis, cell biology, and the molecular mechanisms underlying biological phenomena",
        "works_count": 126,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1302,
            "field_id": 13,
            "name": "Aging",
            "slug": "aging",
            "description": "The biological study of aging processes at molecular, cellular, and organismal levels, including mechanisms of senescence, age-related diseases, longevity, regenerative medicine, and interventions to promote healthy aging",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1303,
            "field_id": 13,
            "name": "Biochemistry",
            "slug": "biochemistry",
            "description": "The chemical processes and substances within living organisms, studying proteins, nucleic acids, carbohydrates, lipids, and their interactions, including enzyme function, metabolic pathways, and molecular mechanisms of life",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1304,
            "field_id": 13,
            "name": "Biophysics",
            "slug": "biophysics",
            "description": "The application of physical principles and methods to understand biological systems, including biomolecular structure and dynamics, membrane biophysics, cellular mechanics, and the development of biophysical techniques",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1305,
            "field_id": 13,
            "name": "Biotechnology",
            "slug": "biotechnology",
            "description": "The application of biological systems and organisms to develop products and technologies, including genetic engineering, synthetic biology, biopharmaceuticals, industrial biotechnology, and agricultural biotechnology applications",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1306,
            "field_id": 13,
            "name": "Cancer Research",
            "slug": "cancer-research",
            "description": "The multidisciplinary study of cancer biology, including carcinogenesis, tumor progression, metastasis, cancer genetics, immunology, and the development of diagnostic, preventive, and therapeutic strategies",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1307,
            "field_id": 13,
            "name": "Cell Biology",
            "slug": "cell-biology",
            "description": "The study of cell structure, function, and behavior, including organelles, cell division, signaling, metabolism, differentiation, and the molecular mechanisms governing cellular processes in health and disease",
            "works_count": 12,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1308,
            "field_id": 13,
            "name": "Clinical Biochemistry",
            "slug": "clinical-biochemistry",
            "description": "The analysis of body fluids and tissues for diagnostic and therapeutic monitoring, including development of biomarkers, clinical assays, point-of-care testing, and the biochemical basis of disease",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1309,
            "field_id": 13,
            "name": "Developmental Biology",
            "slug": "developmental-biology",
            "description": "The study of how organisms grow and develop from fertilization to maturity, including embryogenesis, morphogenesis, cell differentiation, pattern formation, stem cell biology, and regeneration",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1310,
            "field_id": 13,
            "name": "Endocrinology",
            "slug": "endocrinology",
            "description": "The study of hormones and the endocrine system, including hormone synthesis, secretion, and action, endocrine disorders, neuroendocrinology, and the regulation of metabolism, growth, and reproduction",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1300,
            "field_id": 13,
            "name": "General Biochemistry, Genetics and Molecular Biology",
            "slug": "general-biochemistry-genetics-and-molecular-biology",
            "description": "Interdisciplinary research spanning multiple areas of biochemistry, genetics and molecular biology that bridges traditional boundaries within this field",
            "works_count": 6,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1311,
            "field_id": 13,
            "name": "Genetics",
            "slug": "genetics",
            "description": "The study of heredity and genetic variation, including molecular genetics, population genetics, genomics, epigenetics, genetic engineering, and the genetic basis of traits, evolution, and disease",
            "works_count": 22,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1312,
            "field_id": 13,
            "name": "Molecular Biology",
            "slug": "molecular-biology",
            "description": "The molecular mechanisms of biological processes, focusing on DNA, RNA, and protein interactions, gene expression, signal transduction, molecular techniques, and the molecular basis of cellular function",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1313,
            "field_id": 13,
            "name": "Molecular Medicine",
            "slug": "molecular-medicine",
            "description": "The application of molecular biology to understand and treat disease, including molecular diagnostics, personalized medicine, gene therapy, drug development, and translational research from bench to bedside",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1314,
            "field_id": 13,
            "name": "Physiology",
            "slug": "physiology",
            "description": "The study of how organisms function at all levels, from molecules to organ systems, including cardiovascular, respiratory, neural, renal, and digestive physiology, homeostasis, and adaptation to environmental challenges",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1315,
            "field_id": 13,
            "name": "Structural Biology",
            "slug": "structural-biology",
            "description": "The determination and analysis of three-dimensional structures of biological macromolecules, using techniques like crystallography, NMR, and cryo-EM to understand structure-function relationships and drug design",
            "works_count": 12,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          }
        ]
      },
      {
        "id": 24,
        "domain_id": 1,
        "name": "Immunology and Microbiology",
        "slug": "immunology-and-microbiology",
        "description": "The study of microorganisms and the immune system, including bacteria, viruses, fungi, parasites, infectious diseases, immune responses, vaccines, antibiotics, and the complex interactions between pathogens and host defense mechanisms",
        "works_count": 49,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2402,
            "field_id": 24,
            "name": "Applied Microbiology and Biotechnology",
            "slug": "applied-microbiology-and-biotechnology",
            "description": "The practical application of microorganisms, including industrial fermentation, bioremediation, microbial production of chemicals and materials, probiotics, and microbial biotechnology innovations",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2400,
            "field_id": 24,
            "name": "General Immunology and Microbiology",
            "slug": "general-immunology-and-microbiology",
            "description": "Interdisciplinary research spanning multiple areas of immunology and microbiology that bridges traditional boundaries within this field",
            "works_count": 1,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2403,
            "field_id": 24,
            "name": "Immunology",
            "slug": "immunology",
            "description": "The study of immune systems in all organisms, including innate and adaptive immunity, immunological disorders, vaccines, transplantation immunology, and therapeutic immunology approaches",
            "works_count": 21,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2404,
            "field_id": 24,
            "name": "Microbiology",
            "slug": "microbiology",
            "description": "The study of microorganisms, including bacteria, viruses, fungi, and protozoa, their genetics, physiology, ecology, evolution, and roles in health, disease, and the environment",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2405,
            "field_id": 24,
            "name": "Parasitology",
            "slug": "parasitology",
            "description": "The study of parasites and parasitic diseases, including parasite biology, host-parasite interactions, epidemiology of parasitic infections, and the development of antiparasitic interventions",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2406,
            "field_id": 24,
            "name": "Virology",
            "slug": "virology",
            "description": "The study of viruses and viral diseases, including viral structure, replication, pathogenesis, evolution, antiviral drugs, viral vectors, and emerging viral threats to human and animal health",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          }
        ]
      },
      {
        "id": 28,
        "domain_id": 1,
        "name": "Neuroscience",
        "slug": "neuroscience",
        "description": "The scientific study of the nervous system, including brain function, neural development, cognitive processes, behavior, neurological disorders, consciousness, memory, learning, and the biological basis of mental phenomena",
        "works_count": 79,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2802,
            "field_id": 28,
            "name": "Behavioral Neuroscience",
            "slug": "behavioral-neuroscience",
            "description": "Neural mechanisms underlying behavior, including learning, memory, motivation, emotion, addiction, and the use of animal models to understand human behavioral disorders",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2803,
            "field_id": 28,
            "name": "Biological Psychiatry",
            "slug": "biological-psychiatry",
            "description": "The biological basis of psychiatric disorders, including neurotransmitter systems, brain imaging in psychiatry, genetic factors, psychopharmacology, and biomarkers for mental illness",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2804,
            "field_id": 28,
            "name": "Cellular and Molecular Neuroscience",
            "slug": "cellular-and-molecular-neuroscience",
            "description": "Molecular and cellular mechanisms of nervous system function, including synaptic transmission, ion channels, neurotransmitter receptors, signal transduction, and neuronal development",
            "works_count": 12,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2805,
            "field_id": 28,
            "name": "Cognitive Neuroscience",
            "slug": "cognitive-neuroscience",
            "description": "Neural basis of cognitive functions, including attention, perception, language, decision-making, executive function, and the use of neuroimaging to study human cognition",
            "works_count": 17,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2806,
            "field_id": 28,
            "name": "Developmental Neuroscience",
            "slug": "developmental-neuroscience",
            "description": "Development of the nervous system, including neurogenesis, axon guidance, synapse formation, neural plasticity, and developmental disorders of the nervous system",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2807,
            "field_id": 28,
            "name": "Endocrine and Autonomic Systems",
            "slug": "endocrine-and-autonomic-systems",
            "description": "Neuroendocrine regulation and autonomic function, including stress responses, circadian rhythms, autonomic disorders, and the interaction between the nervous and endocrine systems",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2800,
            "field_id": 28,
            "name": "General Neuroscience",
            "slug": "general-neuroscience",
            "description": "Interdisciplinary research spanning multiple areas of neuroscience that bridges traditional boundaries within this field",
            "works_count": 6,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2808,
            "field_id": 28,
            "name": "Neurology",
            "slug": "neurology",
            "description": "Clinical neuroscience and neurological disorders, including neurodegeneration, neuroimmunology, neuromuscular diseases, and translational approaches to neurological treatment",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 2809,
            "field_id": 28,
            "name": "Sensory Systems",
            "slug": "sensory-systems",
            "description": "Neural processing of sensory information, including vision, hearing, touch, taste, smell, pain perception, and the development of sensory prosthetics and interfaces",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          }
        ]
      },
      {
        "id": 30,
        "domain_id": 1,
        "name": "Pharmacology, Toxicology and Pharmaceutics",
        "slug": "pharmacology-toxicology-and-pharmaceutics",
        "description": "The study of drugs and their effects on living systems, including drug discovery, development, and delivery, pharmacokinetics, toxicology, pharmaceutical chemistry, clinical pharmacy, and the safe and effective use of medications",
        "works_count": 38,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3002,
            "field_id": 30,
            "name": "Drug Discovery",
            "slug": "drug-discovery",
            "description": "The identification and development of new therapeutic compounds, including target identification, lead optimization, high-throughput screening, and computational drug design",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 3000,
            "field_id": 30,
            "name": "General Pharmacology, Toxicology and Pharmaceutics",
            "slug": "general-pharmacology-toxicology-and-pharmaceutics",
            "description": "Interdisciplinary research spanning multiple areas of pharmacology, toxicology and pharmaceutics that bridges traditional boundaries within this field",
            "works_count": 1,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 3003,
            "field_id": 30,
            "name": "Pharmaceutical Science",
            "slug": "pharmaceutical-science",
            "description": "Drug formulation and delivery, including pharmaceutics, pharmacokinetics, drug stability, controlled release systems, and the development of novel drug delivery technologies",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 3004,
            "field_id": 30,
            "name": "Pharmacology",
            "slug": "pharmacology",
            "description": "Drug action and effects on biological systems, including molecular pharmacology, neuropharmacology, cardiovascular pharmacology, drug-receptor interactions, and adverse drug reactions",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 3005,
            "field_id": 30,
            "name": "Toxicology",
            "slug": "toxicology",
            "description": "The study of adverse effects of chemicals, including mechanisms of toxicity, risk assessment, environmental toxicology, forensic toxicology, and regulatory toxicology",
            "works_count": 17,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          }
        ]
      }
    ]
  },
  {
    "id": 3,
    "name": "Physical Sciences",
    "slug": "physical-sciences",
    "description": "The study of non-living matter and energy, encompassing physics, chemistry, astronomy, earth sciences, mathematics, computer science, engineering, and materials science, exploring the fundamental laws and principles that govern the natural world",
    "works_count": 708,
    "created_at": "2025-07-11T13:44:30.572372",
    "updated_at": "2025-07-11T13:44:30.572372",
    "fields": [
      {
        "id": 15,
        "domain_id": 3,
        "name": "Chemical Engineering",
        "slug": "chemical-engineering",
        "description": "The application of chemistry, physics, and mathematics to industrial processes, including reactor design, process optimization, materials synthesis, separation technologies, biotechnology applications, and sustainable manufacturing systems",
        "works_count": 18,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1502,
            "field_id": 15,
            "name": "Bioengineering",
            "slug": "bioengineering",
            "description": "The application of engineering principles to biological systems, including bioprocess engineering, metabolic engineering, bioreactor design, fermentation technology, and the production of biopharmaceuticals and biomaterials",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1503,
            "field_id": 15,
            "name": "Catalysis",
            "slug": "catalysis",
            "description": "The science of accelerating chemical reactions using catalysts, including heterogeneous and homogeneous catalysis, enzyme catalysis, catalyst design, reaction mechanisms, and industrial catalytic processes",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1504,
            "field_id": 15,
            "name": "Chemical Health and Safety",
            "slug": "chemical-health-and-safety",
            "description": "The safe handling, storage, and disposal of chemicals in industrial and laboratory settings, including hazard assessment, exposure control, emergency response, regulatory compliance, and process safety management",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1506,
            "field_id": 15,
            "name": "Filtration and Separation",
            "slug": "filtration-and-separation",
            "description": "The design and optimization of separation processes, including membrane technology, chromatography, distillation, extraction, crystallization, and the development of novel separation materials and methods",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1507,
            "field_id": 15,
            "name": "Fluid Flow and Transfer Processes",
            "slug": "fluid-flow-and-transfer-processes",
            "description": "The study of fluid dynamics, heat and mass transfer in chemical processes, including reactor design, mixing, multiphase flow, computational fluid dynamics, and transport phenomena in industrial applications",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1500,
            "field_id": 15,
            "name": "General Chemical Engineering",
            "slug": "general-chemical-engineering",
            "description": "Interdisciplinary research spanning multiple areas of chemical engineering that bridges traditional boundaries within this field",
            "works_count": 0,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1508,
            "field_id": 15,
            "name": "Process Chemistry and Technology",
            "slug": "process-chemistry-and-technology",
            "description": "The development and optimization of chemical manufacturing processes, including process intensification, green chemistry, scale-up, continuous processing, and integration of unit operations for efficient production",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          }
        ]
      },
      {
        "id": 16,
        "domain_id": 3,
        "name": "Chemistry",
        "slug": "chemistry",
        "description": "The study of matter and its properties, reactions, and transformations, including organic, inorganic, physical, and analytical chemistry, as well as the development of new materials, drugs, and understanding of molecular interactions",
        "works_count": 31,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1602,
            "field_id": 16,
            "name": "Analytical Chemistry",
            "slug": "analytical-chemistry",
            "description": "The development and application of methods to identify and quantify matter, including spectroscopy, chromatography, mass spectrometry, electroanalytical techniques, and chemical sensors for various applications",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1603,
            "field_id": 16,
            "name": "Electrochemistry",
            "slug": "electrochemistry",
            "description": "The study of chemical processes involving electron transfer, including batteries, fuel cells, corrosion, electroplating, electroanalysis, and the development of electrochemical sensors and energy storage devices",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1600,
            "field_id": 16,
            "name": "General Chemistry",
            "slug": "general-chemistry",
            "description": "Interdisciplinary research spanning multiple areas of chemistry that bridges traditional boundaries within this field",
            "works_count": 0,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1604,
            "field_id": 16,
            "name": "Inorganic Chemistry",
            "slug": "inorganic-chemistry",
            "description": "The study of inorganic compounds and materials, including coordination chemistry, organometallic chemistry, solid-state chemistry, bioinorganic chemistry, and the synthesis of advanced inorganic materials",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1605,
            "field_id": 16,
            "name": "Organic Chemistry",
            "slug": "organic-chemistry",
            "description": "The study of carbon-containing compounds, including synthesis, reaction mechanisms, stereochemistry, natural products, medicinal chemistry, and the development of new synthetic methodologies",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1606,
            "field_id": 16,
            "name": "Physical and Theoretical Chemistry",
            "slug": "physical-and-theoretical-chemistry",
            "description": "The study of chemical phenomena using physics and mathematical models, including thermodynamics, kinetics, quantum chemistry, statistical mechanics, and computational chemistry methods",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1607,
            "field_id": 16,
            "name": "Spectroscopy",
            "slug": "spectroscopy",
            "description": "The study of matter's interaction with electromagnetic radiation, including NMR, IR, UV-Vis, Raman spectroscopy, and advanced spectroscopic techniques for structural analysis and chemical identification",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          }
        ]
      },
      {
        "id": 17,
        "domain_id": 3,
        "name": "Computer Science",
        "slug": "computer-science",
        "description": "The study of computation, information processing, and intelligent systems, including algorithms, artificial intelligence, machine learning, software engineering, cybersecurity, databases, networks, and human-computer interaction",
        "works_count": 297,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1702,
            "field_id": 17,
            "name": "Artificial Intelligence",
            "slug": "artificial-intelligence",
            "description": "The development of intelligent systems that can perceive, reason, learn, and act, including machine learning, deep learning, natural language processing, robotics, expert systems, and AI ethics",
            "works_count": 193,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1703,
            "field_id": 17,
            "name": "Computational Theory and Mathematics",
            "slug": "computational-theory-and-mathematics",
            "description": "The mathematical foundations of computing, including algorithms, complexity theory, automata theory, formal languages, cryptography, and the theoretical limits of computation",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1704,
            "field_id": 17,
            "name": "Computer Graphics and Computer-Aided Design",
            "slug": "computer-graphics-and-computer-aided-design",
            "description": "The creation and manipulation of visual content using computers, including 3D modeling, rendering, animation, visualization, virtual reality, CAD/CAM systems, and computational geometry",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1705,
            "field_id": 17,
            "name": "Computer Networks and Communications",
            "slug": "computer-networks-and-communications",
            "description": "The design and analysis of communication systems and networks, including protocols, wireless networks, Internet architecture, network security, distributed systems, and emerging networking technologies",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1706,
            "field_id": 17,
            "name": "Computer Science Applications",
            "slug": "computer-science-applications",
            "description": "The practical application of computing to solve real-world problems, including bioinformatics, computational science, digital humanities, e-commerce, social computing, and domain-specific software solutions",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1707,
            "field_id": 17,
            "name": "Computer Vision and Pattern Recognition",
            "slug": "computer-vision-and-pattern-recognition",
            "description": "The automatic extraction and interpretation of information from images and video, including object detection, facial recognition, medical imaging analysis, autonomous vehicles, and visual understanding systems",
            "works_count": 33,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1700,
            "field_id": 17,
            "name": "General Computer Science",
            "slug": "general-computer-science",
            "description": "Interdisciplinary research spanning multiple areas of computer science that bridges traditional boundaries within this field",
            "works_count": 2,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1708,
            "field_id": 17,
            "name": "Hardware and Architecture",
            "slug": "hardware-and-architecture",
            "description": "The design and organization of computer systems, including processor architecture, memory systems, parallel computing, embedded systems, quantum computing hardware, and energy-efficient computing",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1709,
            "field_id": 17,
            "name": "Human-Computer Interaction",
            "slug": "human-computer-interaction",
            "description": "The design and evaluation of user interfaces and interactive systems, including usability, user experience, accessibility, mobile computing, augmented reality, and social aspects of computing",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1710,
            "field_id": 17,
            "name": "Information Systems",
            "slug": "information-systems",
            "description": "The study of how organizations use information technology, including database systems, information retrieval, knowledge management, enterprise systems, and the socio-technical aspects of IT deployment",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1711,
            "field_id": 17,
            "name": "Signal Processing",
            "slug": "signal-processing",
            "description": "The analysis and manipulation of signals, including digital signal processing, image processing, audio processing, compression, filtering, and applications in communications and multimedia",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1712,
            "field_id": 17,
            "name": "Software",
            "slug": "software",
            "description": "The engineering of software systems, including programming languages, software architecture, testing, verification, agile methods, DevOps, and the management of large-scale software projects",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          }
        ]
      },
      {
        "id": 19,
        "domain_id": 3,
        "name": "Earth and Planetary Sciences",
        "slug": "earth-and-planetary-sciences",
        "description": "The study of Earth and other celestial bodies, including geology, oceanography, atmospheric science, climatology, seismology, planetary formation, natural resources, and the physical processes shaping planets and their environments",
        "works_count": 52,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1902,
            "field_id": 19,
            "name": "Atmospheric Science",
            "slug": "atmospheric-science",
            "description": "The study of Earth's atmosphere and its processes, including meteorology, climatology, atmospheric chemistry, air quality, weather prediction, and the impacts of human activities on atmospheric composition",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1904,
            "field_id": 19,
            "name": "Earth-Surface Processes",
            "slug": "earth-surface-processes",
            "description": "The study of processes shaping Earth's surface, including geomorphology, erosion, sedimentation, glaciology, hydrology, and the interactions between climate, tectonics, and landscape evolution",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1900,
            "field_id": 19,
            "name": "General Earth and Planetary Sciences",
            "slug": "general-earth-and-planetary-sciences",
            "description": "Interdisciplinary research spanning multiple areas of earth and planetary sciences that bridges traditional boundaries within this field",
            "works_count": 2,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1906,
            "field_id": 19,
            "name": "Geochemistry and Petrology",
            "slug": "geochemistry-and-petrology",
            "description": "The chemical composition and formation of rocks and minerals, including igneous, metamorphic, and sedimentary processes, isotope geochemistry, and the cycling of elements through Earth systems",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1907,
            "field_id": 19,
            "name": "Geology",
            "slug": "geology",
            "description": "The comprehensive study of Earth's structure, composition, and history, including mineralogy, stratigraphy, structural geology, economic geology, and the reconstruction of Earth's geological past",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1908,
            "field_id": 19,
            "name": "Geophysics",
            "slug": "geophysics",
            "description": "The physics of Earth and its environment, including seismology, gravity, magnetism, electrical methods, and the use of geophysical techniques to explore Earth's interior and natural resources",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1910,
            "field_id": 19,
            "name": "Oceanography",
            "slug": "oceanography",
            "description": "The multidisciplinary study of oceans, including physical oceanography, marine chemistry, biological oceanography, ocean circulation, marine ecosystems, and ocean-atmosphere interactions",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1911,
            "field_id": 19,
            "name": "Paleontology",
            "slug": "paleontology",
            "description": "The study of ancient life through fossils, including evolution, extinction, paleoecology, biostratigraphy, and the reconstruction of past environments and biodiversity through geological time",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 1912,
            "field_id": 19,
            "name": "Space and Planetary Science",
            "slug": "space-and-planetary-science",
            "description": "The study of celestial bodies and space environments, including planetary geology, astrobiology, solar system formation, exoplanets, space weather, and missions to explore other worlds",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          }
        ]
      },
      {
        "id": 21,
        "domain_id": 3,
        "name": "Energy",
        "slug": "energy",
        "description": "The interdisciplinary study of energy systems and technologies, including renewable energy, fossil fuels, nuclear power, energy storage, efficiency, sustainability, climate change mitigation, and the transition to clean energy economies",
        "works_count": 19,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2102,
            "field_id": 21,
            "name": "Energy Engineering and Power Technology",
            "slug": "energy-engineering-and-power-technology",
            "description": "The design and operation of energy conversion and power generation systems, including thermal power plants, renewable energy technologies, energy storage, smart grids, and energy efficiency optimization",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2103,
            "field_id": 21,
            "name": "Fuel Technology",
            "slug": "fuel-technology",
            "description": "The production, processing, and utilization of fuels, including fossil fuels, biofuels, hydrogen, synthetic fuels, combustion technology, and the development of cleaner fuel alternatives",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2100,
            "field_id": 21,
            "name": "General Energy",
            "slug": "general-energy",
            "description": "Comprehensive energy studies covering multiple energy sources and systems, including energy policy, economics, security, sustainability, and the integration of diverse energy technologies",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2104,
            "field_id": 21,
            "name": "Nuclear Energy and Engineering",
            "slug": "nuclear-energy-and-engineering",
            "description": "Nuclear power generation and applications, including reactor design, nuclear fuel cycle, radiation protection, fusion energy research, and the management of nuclear waste and decommissioning",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2105,
            "field_id": 21,
            "name": "Renewable Energy, Sustainability and the Environment",
            "slug": "renewable-energy-sustainability-and-the-environment",
            "description": "Sustainable energy systems and technologies, including solar, wind, hydro, geothermal, and biomass energy, life cycle assessment, carbon mitigation, and the environmental impacts of energy systems",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          }
        ]
      },
      {
        "id": 22,
        "domain_id": 3,
        "name": "Engineering",
        "slug": "engineering",
        "description": "The application of scientific principles to design and build systems, including mechanical, electrical, civil, aerospace, biomedical, and industrial engineering, focusing on solving practical problems and advancing technological innovation",
        "works_count": 51,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2202,
            "field_id": 22,
            "name": "Aerospace Engineering",
            "slug": "aerospace-engineering",
            "description": "The design and development of aircraft and spacecraft, including aerodynamics, propulsion, structures, avionics, orbital mechanics, and the engineering challenges of atmospheric and space flight",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2216,
            "field_id": 22,
            "name": "Architecture",
            "slug": "architecture",
            "description": "The art and science of designing buildings and spaces, including architectural theory, sustainable design, urban planning, building technology, historic preservation, and the social impacts of built environments",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2203,
            "field_id": 22,
            "name": "Automotive Engineering",
            "slug": "automotive-engineering",
            "description": "The design and manufacturing of vehicles, including powertrains, chassis systems, vehicle dynamics, autonomous vehicles, electric vehicles, safety systems, and sustainable transportation technologies",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2204,
            "field_id": 22,
            "name": "Biomedical Engineering",
            "slug": "biomedical-engineering",
            "description": "The application of engineering to medicine and biology, including medical devices, biomaterials, tissue engineering, medical imaging, biomechanics, and the development of diagnostic and therapeutic technologies",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2215,
            "field_id": 22,
            "name": "Building and Construction",
            "slug": "building-and-construction",
            "description": "Construction methods, materials, and management, including sustainable construction, building information modeling, construction safety, project management, and innovations in building technology",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2205,
            "field_id": 22,
            "name": "Civil and Structural Engineering",
            "slug": "civil-and-structural-engineering",
            "description": "The design and analysis of infrastructure and structures, including bridges, buildings, dams, transportation systems, earthquake engineering, and the development of resilient civil infrastructure",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2206,
            "field_id": 22,
            "name": "Computational Mechanics",
            "slug": "computational-mechanics",
            "description": "Numerical methods for solving mechanical problems, including finite element analysis, computational fluid dynamics, multiscale modeling, and the simulation of complex engineering systems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2207,
            "field_id": 22,
            "name": "Control and Systems Engineering",
            "slug": "control-and-systems-engineering",
            "description": "The design of control systems for dynamic processes, including feedback control, robotics, automation, adaptive systems, and the integration of sensors and actuators in intelligent systems",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2208,
            "field_id": 22,
            "name": "Electrical and Electronic Engineering",
            "slug": "electrical-and-electronic-engineering",
            "description": "The study and application of electricity and electronics, including power systems, electronics, telecommunications, signal processing, electromagnetics, and the design of electrical devices and systems",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2200,
            "field_id": 22,
            "name": "General Engineering",
            "slug": "general-engineering",
            "description": "Interdisciplinary engineering research and education covering fundamental engineering principles, systems thinking, engineering design methodology, and cross-cutting engineering challenges",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2209,
            "field_id": 22,
            "name": "Industrial and Manufacturing Engineering",
            "slug": "industrial-and-manufacturing-engineering",
            "description": "The optimization of complex processes and systems, including production planning, quality control, supply chain management, lean manufacturing, automation, and Industry 4.0 technologies",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2210,
            "field_id": 22,
            "name": "Mechanical Engineering",
            "slug": "mechanical-engineering",
            "description": "The design and analysis of mechanical systems, including thermodynamics, fluid mechanics, machine design, robotics, HVAC systems, and the development of innovative mechanical technologies",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2211,
            "field_id": 22,
            "name": "Mechanics of Materials",
            "slug": "mechanics-of-materials",
            "description": "The behavior of solid materials under various conditions, including stress analysis, fracture mechanics, fatigue, composite materials, and the development of advanced structural materials",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2214,
            "field_id": 22,
            "name": "Media Technology",
            "slug": "media-technology",
            "description": "Engineering aspects of media production and distribution, including audio/video technology, streaming systems, virtual production, broadcast engineering, and emerging media platforms",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2212,
            "field_id": 22,
            "name": "Ocean Engineering",
            "slug": "ocean-engineering",
            "description": "Engineering for marine environments, including offshore structures, naval architecture, underwater vehicles, ocean renewable energy, coastal engineering, and marine technology systems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2213,
            "field_id": 22,
            "name": "Safety, Risk, Reliability and Quality",
            "slug": "safety-risk-reliability-and-quality",
            "description": "Engineering approaches to system safety and reliability, including risk assessment, failure analysis, quality assurance, human factors, and the design of fault-tolerant systems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          }
        ]
      },
      {
        "id": 23,
        "domain_id": 3,
        "name": "Environmental Science",
        "slug": "environmental-science",
        "description": "The integrated study of physical, chemical, and biological processes in the environment, including ecology, conservation, pollution, climate change, sustainability, environmental policy, and the impact of human activities on natural systems",
        "works_count": 70,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2302,
            "field_id": 23,
            "name": "Ecological Modeling",
            "slug": "ecological-modeling",
            "description": "Mathematical and computational approaches to understanding ecosystems, including population dynamics, food web models, ecosystem services valuation, and predictive modeling of ecological responses",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2303,
            "field_id": 23,
            "name": "Ecology",
            "slug": "ecology",
            "description": "The study of interactions between organisms and their environment, including community ecology, ecosystem ecology, landscape ecology, conservation biology, and biodiversity patterns and processes",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2304,
            "field_id": 23,
            "name": "Environmental Chemistry",
            "slug": "environmental-chemistry",
            "description": "Chemical processes in the environment, including pollutant fate and transport, atmospheric chemistry, aquatic chemistry, soil chemistry, and the development of green chemistry solutions",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2305,
            "field_id": 23,
            "name": "Environmental Engineering",
            "slug": "environmental-engineering",
            "description": "Engineering solutions for environmental protection, including water and wastewater treatment, air pollution control, solid waste management, remediation technologies, and sustainable engineering design",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2300,
            "field_id": 23,
            "name": "General Environmental Science",
            "slug": "general-environmental-science",
            "description": "Interdisciplinary research spanning multiple areas of environmental science that bridges traditional boundaries within this field",
            "works_count": 3,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2306,
            "field_id": 23,
            "name": "Global and Planetary Change",
            "slug": "global-and-planetary-change",
            "description": "Large-scale environmental changes, including climate change, biogeochemical cycles, land use change, sea level rise, and the impacts of human activities on Earth system processes",
            "works_count": 23,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2307,
            "field_id": 23,
            "name": "Health, Toxicology and Mutagenesis",
            "slug": "health-toxicology-and-mutagenesis",
            "description": "Environmental impacts on human health, including exposure assessment, ecotoxicology, environmental epidemiology, risk assessment, and the effects of pollutants on genetic material",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2311,
            "field_id": 23,
            "name": "Industrial and Manufacturing Engineering",
            "slug": "industrial-and-manufacturing-engineering",
            "description": "Sustainable manufacturing and industrial ecology, including cleaner production, life cycle assessment, circular economy, eco-design, and the environmental optimization of industrial processes",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2308,
            "field_id": 23,
            "name": "Management, Monitoring, Policy and Law",
            "slug": "management-monitoring-policy-and-law",
            "description": "Environmental governance and management, including environmental policy, regulation, monitoring systems, environmental impact assessment, and international environmental agreements",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2309,
            "field_id": 23,
            "name": "Nature and Landscape Conservation",
            "slug": "nature-and-landscape-conservation",
            "description": "Conservation science and practice, including protected area management, habitat restoration, species conservation, landscape ecology, and the integration of human activities with conservation goals",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2310,
            "field_id": 23,
            "name": "Pollution",
            "slug": "pollution",
            "description": "The study and control of environmental contamination, including air, water, and soil pollution, noise pollution, plastic pollution, pollution prevention, and the development of cleanup technologies",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          },
          {
            "id": 2312,
            "field_id": 23,
            "name": "Water Science and Technology",
            "slug": "water-science-and-technology",
            "description": "All aspects of water resources, including hydrology, water quality, aquatic ecosystems, water treatment technologies, water resource management, and solutions for water scarcity",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.0629",
            "updated_at": "2025-07-11T14:10:35.0629"
          }
        ]
      },
      {
        "id": 25,
        "domain_id": 3,
        "name": "Materials Science",
        "slug": "materials-science",
        "description": "The study of the properties and applications of materials, including metals, ceramics, polymers, composites, nanomaterials, semiconductors, and biomaterials, focusing on structure-property relationships and novel material development",
        "works_count": 37,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2502,
            "field_id": 25,
            "name": "Biomaterials",
            "slug": "biomaterials",
            "description": "Materials for medical and biological applications, including implants, tissue engineering scaffolds, drug delivery systems, biocompatibility, and the interaction between materials and biological systems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2503,
            "field_id": 25,
            "name": "Ceramics and Composites",
            "slug": "ceramics-and-composites",
            "description": "Advanced ceramic materials and composite systems, including structural ceramics, functional ceramics, fiber-reinforced composites, nanocomposites, and high-temperature materials",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2504,
            "field_id": 25,
            "name": "Electronic, Optical and Magnetic Materials",
            "slug": "electronic-optical-and-magnetic-materials",
            "description": "Materials for electronic and photonic applications, including semiconductors, superconductors, magnetic materials, photonic crystals, metamaterials, and quantum materials",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2500,
            "field_id": 25,
            "name": "General Materials Science",
            "slug": "general-materials-science",
            "description": "Fundamental materials research spanning multiple material classes, including materials characterization, processing-structure-property relationships, and cross-cutting materials phenomena",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2505,
            "field_id": 25,
            "name": "Materials Chemistry",
            "slug": "materials-chemistry",
            "description": "Chemical approaches to materials synthesis and modification, including sol-gel processing, self-assembly, surface chemistry, catalytic materials, and chemically derived nanomaterials",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2506,
            "field_id": 25,
            "name": "Metals and Alloys",
            "slug": "metals-and-alloys",
            "description": "Metallic materials and their properties, including alloy design, metallurgy, corrosion, metal processing, high-entropy alloys, and advanced metallic materials for structural applications",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2507,
            "field_id": 25,
            "name": "Polymers and Plastics",
            "slug": "polymers-and-plastics",
            "description": "Synthetic and natural polymeric materials, including polymer synthesis, characterization, processing, polymer physics, biodegradable polymers, and functional polymer systems",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2508,
            "field_id": 25,
            "name": "Surfaces, Coatings and Films",
            "slug": "surfaces-coatings-and-films",
            "description": "Surface engineering and thin film technologies, including surface modification, protective coatings, functional films, tribology, and advanced deposition techniques",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          }
        ]
      },
      {
        "id": 26,
        "domain_id": 3,
        "name": "Mathematics",
        "slug": "mathematics",
        "description": "The study of abstract structures, patterns, and relationships, including pure mathematics (algebra, analysis, geometry, topology), applied mathematics, statistics, computational mathematics, and the mathematical foundations underlying all sciences",
        "works_count": 41,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2602,
            "field_id": 26,
            "name": "Algebra and Number Theory",
            "slug": "algebra-and-number-theory",
            "description": "Abstract algebraic structures and properties of integers, including groups, rings, fields, algebraic geometry, arithmetic geometry, and applications to cryptography and coding theory",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2604,
            "field_id": 26,
            "name": "Applied Mathematics",
            "slug": "applied-mathematics",
            "description": "Mathematical methods for real-world problems, including differential equations, optimization, mathematical modeling, dynamical systems, and applications in science, engineering, and industry",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2605,
            "field_id": 26,
            "name": "Computational Mathematics",
            "slug": "computational-mathematics",
            "description": "Numerical algorithms and computational techniques, including numerical analysis, scientific computing, high-performance computing, computational algebra, and mathematical software development",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2607,
            "field_id": 26,
            "name": "Discrete Mathematics and Combinatorics",
            "slug": "discrete-mathematics-and-combinatorics",
            "description": "Mathematics of discrete structures, including graph theory, combinatorial optimization, coding theory, discrete geometry, and applications to computer science and operations research",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2600,
            "field_id": 26,
            "name": "General Mathematics",
            "slug": "general-mathematics",
            "description": "Interdisciplinary research spanning multiple areas of mathematics that bridges traditional boundaries within this field",
            "works_count": 1,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 2608,
            "field_id": 26,
            "name": "Geometry and Topology",
            "slug": "geometry-and-topology",
            "description": "The study of shape, space, and continuous deformations, including differential geometry, algebraic topology, geometric analysis, and applications to physics and data analysis",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2610,
            "field_id": 26,
            "name": "Mathematical Physics",
            "slug": "mathematical-physics",
            "description": "Mathematical foundations of physical theories, including quantum mechanics, statistical mechanics, general relativity, string theory, and the development of rigorous mathematical frameworks for physics",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2611,
            "field_id": 26,
            "name": "Modeling and Simulation",
            "slug": "modeling-and-simulation",
            "description": "Mathematical representation and computer simulation of complex systems, including agent-based models, Monte Carlo methods, system dynamics, and validation of computational models",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2612,
            "field_id": 26,
            "name": "Numerical Analysis",
            "slug": "numerical-analysis",
            "description": "The development and analysis of algorithms for numerical computation, including error analysis, stability, convergence, and efficient methods for solving mathematical problems computationally",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2613,
            "field_id": 26,
            "name": "Statistics and Probability",
            "slug": "statistics-and-probability",
            "description": "Mathematical frameworks for data analysis and uncertainty, including statistical theory, probability theory, stochastic processes, statistical inference, and applications to data science",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          },
          {
            "id": 2614,
            "field_id": 26,
            "name": "Theoretical Computer Science",
            "slug": "theoretical-computer-science",
            "description": "Mathematical aspects of computation, including algorithms, computational complexity, automata theory, formal methods, quantum computing theory, and the foundations of computer science",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:35.434287",
            "updated_at": "2025-07-11T14:10:35.434287"
          }
        ]
      },
      {
        "id": 31,
        "domain_id": 3,
        "name": "Physics and Astronomy",
        "slug": "physics-and-astronomy",
        "description": "The fundamental study of matter, energy, and the universe, including quantum mechanics, relativity, particle physics, astrophysics, cosmology, condensed matter physics, and the exploration of natural laws governing physical phenomena",
        "works_count": 92,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3102,
            "field_id": 31,
            "name": "Acoustics and Ultrasonics",
            "slug": "acoustics-and-ultrasonics",
            "description": "The physics of sound and ultrasound, including wave propagation, acoustic materials, noise control, ultrasonic imaging, acoustic metamaterials, and applications in medicine and industry",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 3103,
            "field_id": 31,
            "name": "Astronomy and Astrophysics",
            "slug": "astronomy-and-astrophysics",
            "description": "The study of celestial objects and cosmic phenomena, including stellar evolution, galaxies, cosmology, exoplanets, gravitational waves, and observational astronomy techniques",
            "works_count": 30,
            "created_at": "2025-07-11T14:10:36.204933",
            "updated_at": "2025-07-11T14:10:36.204933"
          },
          {
            "id": 3107,
            "field_id": 31,
            "name": "Atomic and Molecular Physics, and Optics",
            "slug": "atomic-and-molecular-physics-and-optics",
            "description": "The physics of atoms, molecules, and light, including quantum optics, laser physics, spectroscopy, photonics, quantum information, and optical technologies",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3104,
            "field_id": 31,
            "name": "Condensed Matter Physics",
            "slug": "condensed-matter-physics",
            "description": "The physics of solid and liquid matter, including semiconductors, superconductors, magnetism, phase transitions, nanophysics, and quantum materials",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3100,
            "field_id": 31,
            "name": "General Physics and Astronomy",
            "slug": "general-physics-and-astronomy",
            "description": "Interdisciplinary research spanning multiple areas of physics and astronomy that bridges traditional boundaries within this field",
            "works_count": 7,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 3105,
            "field_id": 31,
            "name": "Instrumentation",
            "slug": "instrumentation",
            "description": "Scientific instrument development and measurement techniques, including detectors, sensors, imaging systems, precision measurement, and instrumentation for research facilities",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3106,
            "field_id": 31,
            "name": "Nuclear and High Energy Physics",
            "slug": "nuclear-and-high-energy-physics",
            "description": "Fundamental particles and nuclear physics, including particle accelerators, quarks and leptons, nuclear structure, particle detectors, and the search for new physics",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3108,
            "field_id": 31,
            "name": "Radiation",
            "slug": "radiation",
            "description": "The physics and applications of ionizing radiation, including radiation detection, dosimetry, radiation therapy, radiation protection, and nuclear medicine physics",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3109,
            "field_id": 31,
            "name": "Statistical and Nonlinear Physics",
            "slug": "statistical-and-nonlinear-physics",
            "description": "Complex systems and statistical physics, including chaos theory, complex networks, soft matter physics, biophysics, and emergent phenomena in many-body systems",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          }
        ]
      }
    ]
  },
  {
    "id": 2,
    "name": "Social Sciences",
    "slug": "social-sciences",
    "description": "The systematic study of human society and social relationships, including economics, psychology, sociology, political science, anthropology, education, law, linguistics, and the humanities, examining how people interact with one another and shape civilizations",
    "works_count": 320,
    "created_at": "2025-07-11T13:44:30.572372",
    "updated_at": "2025-07-11T13:44:30.572372",
    "fields": [
      {
        "id": 12,
        "domain_id": 2,
        "name": "Arts and Humanities",
        "slug": "arts-and-humanities",
        "description": "The study of human culture and creative expression, including literature, philosophy, history, linguistics, music, visual arts, performing arts, cultural studies, and the exploration of human values, ideas, and artistic achievements",
        "works_count": 48,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1204,
            "field_id": 12,
            "name": "Archeology",
            "slug": "archeology",
            "description": "The scientific study of human history and prehistory through the excavation and analysis of artifacts, structures, and cultural remains, including field methods, dating techniques, and interpretations of past societies",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1205,
            "field_id": 12,
            "name": "Classics",
            "slug": "classics",
            "description": "The study of ancient Greek and Roman civilizations, including their languages, literature, history, philosophy, art, and cultural legacy, examining texts, archaeological evidence, and their influence on modern society",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1206,
            "field_id": 12,
            "name": "Conservation",
            "slug": "conservation",
            "description": "The preservation and restoration of cultural heritage, including artworks, historical documents, archaeological artifacts, and architectural monuments, using scientific analysis, ethical practices, and preventive care strategies",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1200,
            "field_id": 12,
            "name": "General Arts and Humanities",
            "slug": "general-arts-and-humanities",
            "description": "Interdisciplinary scholarship that bridges multiple humanities disciplines, exploring human culture, creativity, and expression through integrated approaches to art, literature, history, philosophy, and cultural studies",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1202,
            "field_id": 12,
            "name": "History",
            "slug": "history",
            "description": "The systematic study and interpretation of past events, societies, and cultures through primary sources, archives, and historiographical methods, examining political, social, economic, and cultural developments across time and geography",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1207,
            "field_id": 12,
            "name": "History and Philosophy of Science",
            "slug": "history-and-philosophy-of-science",
            "description": "The examination of scientific development, methodology, and epistemology across history, analyzing how scientific knowledge is constructed, validated, and changes over time, including the social and cultural contexts of scientific practice",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1203,
            "field_id": 12,
            "name": "Language and Linguistics",
            "slug": "language-and-linguistics",
            "description": "The scientific study of human language structure, acquisition, use, and evolution, including phonetics, syntax, semantics, pragmatics, sociolinguistics, and the documentation of endangered languages",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1208,
            "field_id": 12,
            "name": "Literature and Literary Theory",
            "slug": "literature-and-literary-theory",
            "description": "The analysis and interpretation of written texts across cultures and periods, including critical theory, comparative literature, genre studies, narrative analysis, and the exploration of literature's role in society and human experience",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1209,
            "field_id": 12,
            "name": "Museology",
            "slug": "museology",
            "description": "The theory and practice of museum operations, including collection management, exhibition design, educational programming, digital curation, audience engagement, and the role of museums in preserving and interpreting cultural heritage",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:33.800581",
            "updated_at": "2025-07-11T14:10:33.800581"
          },
          {
            "id": 1210,
            "field_id": 12,
            "name": "Music",
            "slug": "music",
            "description": "The academic study of music in all its forms, including music theory, composition, performance, ethnomusicology, music history, acoustics, and the cultural, social, and cognitive aspects of musical expression",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1211,
            "field_id": 12,
            "name": "Philosophy",
            "slug": "philosophy",
            "description": "The systematic investigation of fundamental questions about existence, knowledge, values, reason, mind, and language, including metaphysics, epistemology, ethics, logic, aesthetics, and political philosophy",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1212,
            "field_id": 12,
            "name": "Religious studies",
            "slug": "religious-studies",
            "description": "The academic examination of religious beliefs, practices, institutions, and experiences across cultures, including comparative religion, theology, sacred texts, ritual studies, and the role of religion in contemporary society",
            "works_count": 0,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1213,
            "field_id": 12,
            "name": "Visual Arts and Performing Arts",
            "slug": "visual-arts-and-performing-arts",
            "description": "The study and practice of artistic expression through visual media and performance, including painting, sculpture, photography, theater, dance, film, and digital arts, examining both creative processes and critical analysis",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          }
        ]
      },
      {
        "id": 14,
        "domain_id": 2,
        "name": "Business, Management and Accounting",
        "slug": "business-management-and-accounting",
        "description": "The study of organizational operations, strategy, and financial management, including entrepreneurship, marketing, human resources, operations management, leadership, corporate finance, accounting principles, and business analytics",
        "works_count": 36,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1402,
            "field_id": 14,
            "name": "Accounting",
            "slug": "accounting",
            "description": "The measurement, processing, and communication of financial information, including financial accounting, managerial accounting, auditing, taxation, forensic accounting, and accounting information systems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1403,
            "field_id": 14,
            "name": "Business and International Management",
            "slug": "business-and-international-management",
            "description": "The study of global business operations and cross-cultural management, including international strategy, global supply chains, foreign market entry, multinational corporations, and managing diversity in international contexts",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.024012",
            "updated_at": "2025-07-11T14:10:34.024012"
          },
          {
            "id": 1400,
            "field_id": 14,
            "name": "General Business, Management and Accounting",
            "slug": "general-business-management-and-accounting",
            "description": "Interdisciplinary research spanning multiple areas of business, management and accounting that bridges traditional boundaries within this field",
            "works_count": 0,
            "created_at": "2025-07-20T13:17:22.581562",
            "updated_at": "2025-07-20T13:17:22.581562"
          },
          {
            "id": 1410,
            "field_id": 14,
            "name": "Industrial relations",
            "slug": "industrial-relations",
            "description": "The study of employment relationships between workers, employers, and governments, including labor unions, collective bargaining, workplace conflict resolution, employment law, and human resource policies",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1404,
            "field_id": 14,
            "name": "Management Information Systems",
            "slug": "management-information-systems",
            "description": "The design, implementation, and management of information technology in organizations, including enterprise systems, business intelligence, IT strategy, cybersecurity management, and digital transformation",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1405,
            "field_id": 14,
            "name": "Management of Technology and Innovation",
            "slug": "management-of-technology-and-innovation",
            "description": "The strategic management of technological change and innovation processes, including R&D management, technology transfer, innovation ecosystems, intellectual property, and commercialization of new technologies",
            "works_count": 8,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1406,
            "field_id": 14,
            "name": "Marketing",
            "slug": "marketing",
            "description": "The study of market dynamics and consumer behavior to create, communicate, and deliver value, including market research, branding, digital marketing, consumer psychology, pricing strategies, and marketing analytics",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1407,
            "field_id": 14,
            "name": "Organizational Behavior and Human Resource Management",
            "slug": "organizational-behavior-and-human-resource-management",
            "description": "The study of human behavior in organizational settings and management of human capital, including leadership, motivation, team dynamics, organizational culture, talent management, and employee development",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1408,
            "field_id": 14,
            "name": "Strategy and Management",
            "slug": "strategy-and-management",
            "description": "The formulation and implementation of organizational strategies for competitive advantage, including strategic planning, corporate governance, organizational design, change management, and performance measurement",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          },
          {
            "id": 1409,
            "field_id": 14,
            "name": "Tourism, Leisure and Hospitality Management",
            "slug": "tourism-leisure-and-hospitality-management",
            "description": "The management of tourism destinations, hospitality services, and leisure activities, including sustainable tourism, destination marketing, hotel and restaurant management, event planning, and tourist behavior",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.277086",
            "updated_at": "2025-07-11T14:10:34.277086"
          }
        ]
      },
      {
        "id": 18,
        "domain_id": 2,
        "name": "Decision Sciences",
        "slug": "decision-sciences",
        "description": "The application of quantitative methods to improve decision-making, including operations research, management science, statistics, risk analysis, game theory, optimization, and data-driven approaches to complex business and societal problems",
        "works_count": 16,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 1800,
            "field_id": 18,
            "name": "General Decision Sciences",
            "slug": "general-decision-sciences",
            "description": "Interdisciplinary approaches to decision-making that combine multiple methodologies, including behavioral decision theory, multi-criteria analysis, and integrated frameworks for complex decision problems",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1802,
            "field_id": 18,
            "name": "Information Systems and Management",
            "slug": "information-systems-and-management",
            "description": "The strategic use of information systems for decision support, including business intelligence, data analytics, knowledge management systems, and IT governance for organizational decision-making",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1803,
            "field_id": 18,
            "name": "Management Science and Operations Research",
            "slug": "management-science-and-operations-research",
            "description": "Mathematical and analytical methods for optimal decision-making, including linear programming, simulation, queuing theory, supply chain optimization, and quantitative models for business operations",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          },
          {
            "id": 1804,
            "field_id": 18,
            "name": "Statistics, Probability and Uncertainty",
            "slug": "statistics-probability-and-uncertainty",
            "description": "Mathematical frameworks for analyzing data and uncertainty, including statistical inference, Bayesian methods, risk analysis, stochastic processes, and decision-making under uncertainty",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:34.504751",
            "updated_at": "2025-07-11T14:10:34.504751"
          }
        ]
      },
      {
        "id": 20,
        "domain_id": 2,
        "name": "Economics, Econometrics and Finance",
        "slug": "economics-econometrics-and-finance",
        "description": "The study of resource allocation, market behavior, and financial systems, including microeconomics, macroeconomics, international trade, monetary policy, financial markets, investment analysis, and quantitative economic modeling",
        "works_count": 41,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 2002,
            "field_id": 20,
            "name": "Economics and Econometrics",
            "slug": "economics-and-econometrics",
            "description": "Economic theory and quantitative analysis of economic phenomena, including microeconomic and macroeconomic theory, econometric modeling, causal inference, and empirical testing of economic hypotheses",
            "works_count": 26,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2003,
            "field_id": 20,
            "name": "Finance",
            "slug": "finance",
            "description": "The study of financial markets, institutions, and decision-making, including corporate finance, investments, financial derivatives, risk management, behavioral finance, and financial regulation",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          },
          {
            "id": 2000,
            "field_id": 20,
            "name": "General Economics, Econometrics and Finance",
            "slug": "general-economics-econometrics-and-finance",
            "description": "Broad economic and financial research spanning multiple subfields, including interdisciplinary work on economic development, financial systems, monetary economics, and integrated economic-financial modeling",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:34.846385",
            "updated_at": "2025-07-11T14:10:34.846385"
          }
        ]
      },
      {
        "id": 32,
        "domain_id": 2,
        "name": "Psychology",
        "slug": "psychology",
        "description": "The scientific study of mind and behavior, including cognitive processes, emotional development, social interactions, mental health, personality, human development, clinical psychology, and the biological bases of psychological phenomena",
        "works_count": 61,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3202,
            "field_id": 32,
            "name": "Applied Psychology",
            "slug": "applied-psychology",
            "description": "Practical applications of psychological principles, including industrial-organizational psychology, forensic psychology, sport psychology, environmental psychology, and consumer psychology",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3203,
            "field_id": 32,
            "name": "Clinical Psychology",
            "slug": "clinical-psychology",
            "description": "Assessment and treatment of mental health disorders, including psychotherapy, psychological testing, clinical interventions, evidence-based treatments, and mental health services",
            "works_count": 9,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3204,
            "field_id": 32,
            "name": "Developmental and Educational Psychology",
            "slug": "developmental-and-educational-psychology",
            "description": "Human development and learning across the lifespan, including cognitive development, social development, educational interventions, learning disabilities, and school psychology",
            "works_count": 10,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3205,
            "field_id": 32,
            "name": "Experimental and Cognitive Psychology",
            "slug": "experimental-and-cognitive-psychology",
            "description": "Basic psychological processes, including perception, attention, memory, thinking, problem-solving, language processing, and experimental methods in psychology",
            "works_count": 15,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3200,
            "field_id": 32,
            "name": "General Psychology",
            "slug": "general-psychology",
            "description": "Broad psychological topics spanning multiple subfields, including psychological theory, history of psychology, research methods, and integrative approaches to understanding behavior",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3206,
            "field_id": 32,
            "name": "Neuropsychology and Physiological Psychology",
            "slug": "neuropsychology-and-physiological-psychology",
            "description": "Brain-behavior relationships, including cognitive neuropsychology, clinical neuropsychology, psychophysiology, brain imaging in psychology, and biological bases of behavior",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3207,
            "field_id": 32,
            "name": "Social Psychology",
            "slug": "social-psychology",
            "description": "How people think about and interact with others, including attitudes, social cognition, group dynamics, prejudice, interpersonal relationships, and cultural psychology",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          }
        ]
      },
      {
        "id": 33,
        "domain_id": 2,
        "name": "Social Sciences",
        "slug": "social-sciences",
        "description": "The study of human society and social relationships, including sociology, anthropology, political science, geography, communication studies, international relations, urban planning, and the systematic analysis of social structures and cultural practices",
        "works_count": 118,
        "created_at": "2025-07-11T13:50:43.330586",
        "updated_at": "2025-07-11T13:50:43.330586",
        "subfields": [
          {
            "id": 3314,
            "field_id": 33,
            "name": "Anthropology",
            "slug": "anthropology",
            "description": "The holistic study of humanity, including cultural anthropology, physical anthropology, linguistic anthropology, archaeological anthropology, and applied anthropology",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3302,
            "field_id": 33,
            "name": "Archeology",
            "slug": "archeology",
            "description": "The study of human past through material remains, including excavation methods, artifact analysis, cultural heritage management, and reconstructing ancient societies",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3315,
            "field_id": 33,
            "name": "Communication",
            "slug": "communication",
            "description": "Human communication processes and media, including mass communication, interpersonal communication, digital media, journalism, public relations, and communication technology",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3316,
            "field_id": 33,
            "name": "Cultural Studies",
            "slug": "cultural-studies",
            "description": "The analysis of contemporary culture and society, including popular culture, media studies, postcolonial studies, critical theory, and the politics of representation",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3317,
            "field_id": 33,
            "name": "Demography",
            "slug": "demography",
            "description": "Population studies and dynamics, including fertility, mortality, migration, population aging, demographic methods, and the social and economic implications of population change",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3303,
            "field_id": 33,
            "name": "Development",
            "slug": "development",
            "description": "International development and social change, including economic development, sustainable development, poverty reduction, development policy, and global inequality",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3304,
            "field_id": 33,
            "name": "Education",
            "slug": "education",
            "description": "Educational theory and practice, including curriculum development, educational policy, teacher education, educational technology, assessment, and comparative education",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.416942",
            "updated_at": "2025-07-11T14:10:36.416942"
          },
          {
            "id": 3318,
            "field_id": 33,
            "name": "Gender Studies",
            "slug": "gender-studies",
            "description": "The study of gender and sexuality, including feminist theory, masculinity studies, LGBTQ+ studies, gender inequality, and the intersection of gender with other social categories",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3300,
            "field_id": 33,
            "name": "General Social Sciences",
            "slug": "general-social-sciences",
            "description": "Interdisciplinary social science research, including mixed methods approaches, social theory, comparative studies, and research addressing complex social issues",
            "works_count": 7,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3305,
            "field_id": 33,
            "name": "Geography, Planning and Development",
            "slug": "geography-planning-and-development",
            "description": "Spatial aspects of human society, including human geography, urban planning, regional development, GIS applications, environmental planning, and sustainable development",
            "works_count": 5,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3306,
            "field_id": 33,
            "name": "Health",
            "slug": "health",
            "description": "Social dimensions of health and healthcare, including health sociology, medical anthropology, health policy, health disparities, and social determinants of health",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3307,
            "field_id": 33,
            "name": "Human Factors and Ergonomics",
            "slug": "human-factors-and-ergonomics",
            "description": "The design of systems for human use, including workplace ergonomics, human-machine interaction, safety engineering, cognitive ergonomics, and user-centered design",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3308,
            "field_id": 33,
            "name": "Law",
            "slug": "law",
            "description": "Legal systems and jurisprudence, including comparative law, international law, constitutional law, legal theory, law and society, and interdisciplinary legal studies",
            "works_count": 6,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3309,
            "field_id": 33,
            "name": "Library and Information Sciences",
            "slug": "library-and-information-sciences",
            "description": "Information organization and access, including digital libraries, information retrieval, knowledge organization, information literacy, archives, and information policy",
            "works_count": 11,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3319,
            "field_id": 33,
            "name": "Life-span and Life-course Studies",
            "slug": "life-span-and-life-course-studies",
            "description": "Human development across the life course, including aging studies, life transitions, intergenerational relationships, life course epidemiology, and biographical research",
            "works_count": 4,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3310,
            "field_id": 33,
            "name": "Linguistics and Language",
            "slug": "linguistics-and-language",
            "description": "The scientific study of language, including theoretical linguistics, applied linguistics, psycholinguistics, computational linguistics, language documentation, and multilingualism",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3320,
            "field_id": 33,
            "name": "Political Science and International Relations",
            "slug": "political-science-and-international-relations",
            "description": "Politics and governance at all levels, including comparative politics, international relations, political theory, public policy, diplomacy, and global governance",
            "works_count": 16,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3321,
            "field_id": 33,
            "name": "Public Administration",
            "slug": "public-administration",
            "description": "Government operations and public management, including public policy implementation, bureaucracy, public sector reform, e-government, and nonprofit management",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3311,
            "field_id": 33,
            "name": "Safety Research",
            "slug": "safety-research",
            "description": "Prevention of accidents and injuries, including occupational safety, transportation safety, product safety, risk perception, safety culture, and accident investigation",
            "works_count": 2,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3312,
            "field_id": 33,
            "name": "Sociology and Political Science",
            "slug": "sociology-and-political-science",
            "description": "Social structures and political processes, including social movements, political sociology, social inequality, power relations, and the intersection of society and politics",
            "works_count": 13,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3313,
            "field_id": 33,
            "name": "Transportation",
            "slug": "transportation",
            "description": "Movement of people and goods, including transportation planning, traffic engineering, logistics, sustainable transportation, transportation economics, and mobility studies",
            "works_count": 1,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          },
          {
            "id": 3322,
            "field_id": 33,
            "name": "Urban Studies",
            "slug": "urban-studies",
            "description": "Cities and urbanization processes, including urban sociology, urban economics, housing studies, urban governance, smart cities, and urban sustainability",
            "works_count": 3,
            "created_at": "2025-07-11T14:10:36.632576",
            "updated_at": "2025-07-11T14:10:36.632576"
          }
        ]
      }
    ]
  }
]